import styled from 'styled-components'
import { theme } from '../../../styles/theme'

export const Text = styled.p`
  font-size: ${theme.font.sizes.medium};
  font-family: ${theme.font.inter};
  line-height: ${theme.font.sizes.large};
  color: ${theme.colors.brown};
`
